export enum IconBehavior {
  None = '',
  Spin = ' fa-spin',
}
